module.exports = __webpack_public_path__ + "static/media/Carregando_NEXT.8f8ec2db.svg";